import React, { useState } from "react";
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Grid,
  Card,
  FormControl,
  InputLabel,
  Select,
  IconButton,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { layoutCSS } from "../component/common/commonStyle";

const StartClicker = () => {
  const [landingPages, setLandingPages] = useState([
    {
      id: 1,
      date: "26/07/2023",
      name: "BSP",
      linkType: "Website",
      url: "http://bsp.com",
    },
    {
      id: 2,
      date: "26/07/2023",
      name: "SAMPLE",
      linkType: "Website",
      url: "http://sample.com",
    },
    {
      id: 3,
      date: "23/08/2023",
      name: "sample_landing",
      linkType: "Website",
      url: "http://samplelanding.com",
    },
    {
      id: 4,
      date: "20/09/2023",
      name: "demo1",
      linkType: "Website",
      url: "http://demo1.com",
    },
    {
      id: 5,
      date: "25/09/2023",
      name: "demo2",
      linkType: "Youtube",
      url: "http://youtube.com/demo2",
    },
  ]);

  const [open, setOpen] = useState(false);
  const [newLanding, setNewLanding] = useState({
    name: "",
    linkType: "Website",
    url: "",
  });

  const [editingId, setEditingId] = useState(null);
  const [editingData, setEditingData] = useState(null);

  const handleChange = (e) => {
    setNewLanding({ ...newLanding, [e.target.name]: e.target.value });
  };

  const handleEditChange = (e) => {
    setEditingData({ ...editingData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (!newLanding.name || !newLanding.url) {
      return;
    }
    const newEntry = {
      id: landingPages.length + 1,
      date: new Date().toLocaleDateString(),
      ...newLanding,
    };
    setLandingPages([...landingPages, newEntry]);
    setOpen(false);
    setNewLanding({ name: "", linkType: "Website", url: "" });
  };

  const handleEditSubmit = () => {
    if (!editingData.name || !editingData.url) {
      return;
    }
    setLandingPages(
      landingPages.map((item) =>
        item.id === editingId ? { ...item, ...editingData } : item
      )
    );
    setEditingId(null);
    setEditingData(null);
    setOpen(false);
  };

  const handleDelete = (id) => {
    setLandingPages(landingPages.filter((item) => item.id !== id));
  };

  const handleEdit = (row) => {
    setEditingId(row.id);
    setEditingData(row);
    setOpen(true);
  };

  const SectionTitle = ({ title }) => (
    <Typography
      sx={{
        fontSize: "13px",
        fontWeight: 600,
        mb: 1.5,
        color: "#0F172A",
      }}
    >
      {title}
    </Typography>
  );

  const compactField = {
    "& .MuiInputBase-root": {
      height: 34,
      fontSize: "0.75rem",
      backgroundColor: "#fff",
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.7rem",
    },
  };

  return (
    <Box sx={{ p: 1.5, minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
      <Grid2 container spacing={2}>
        {/* Left Column - Form */}
        <Grid2 size={8}>
          <Card sx={{ p: 1.5, borderRadius: "12px", border: "1px solid #E2E8F0", mb: 2 }}>
            {/* Create Landing Page Form */}
            <Box sx={{ mb: 2 }}>
              <SectionTitle title="Create New Landing Page" />
              <Grid2 container spacing={1.5}>
                <Grid2 size={6}>
                  <TextField
                    label="Landing Page Name"
                    name="name"
                    fullWidth
                    size="small"
                    value={newLanding.name}
                    onChange={handleChange}
                    sx={compactField}
                    placeholder="Enter page name"
                  />
                </Grid2>
                <Grid2 size={6}>
                  <FormControl fullWidth size="small" sx={compactField}>
                    <InputLabel sx={{ fontSize: "0.7rem" }}>Link Type</InputLabel>
                    <Select
                      label="Link Type"
                      name="linkType"
                      value={newLanding.linkType}
                      onChange={handleChange}
                      sx={{ backgroundColor: "#fff" }}
                    >
                      <MenuItem value="Website">Website</MenuItem>
                      <MenuItem value="Youtube">YouTube</MenuItem>
                      <MenuItem value="Custom">Custom</MenuItem>
                    </Select>
                  </FormControl>
                </Grid2>
                <Grid2 size={12}>
                  <TextField
                    label="Enter URL"
                    name="url"
                    fullWidth
                    size="small"
                    value={newLanding.url}
                    onChange={handleChange}
                    sx={compactField}
                    placeholder="Ex. http://www.example.com"
                  />
                </Grid2>
              </Grid2>
            </Box>

            {/* Submit Button */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
              <Button
                variant="contained"
                size="small"
                onClick={handleSubmit}
                sx={{ fontSize: "0.72rem", textTransform: "none", px: 2 }}
              >
                Add Landing Page
              </Button>
            </Box>
          </Card>

          {/* Landing Pages Table */}
          <Card sx={{ borderRadius: "12px", border: "1px solid #E2E8F0", overflow: "hidden" }}>
            <Box sx={{ p: 1.5 }}>
              <SectionTitle title={`Landing Pages (${landingPages.length})`} />
            </Box>
            <TableContainer sx={{ maxHeight: 500 }}>
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#F8FAFC" }}>
                  <TableRow>
                    <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600, width: "8%" }}>#</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600 }}>Name</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600 }}>Type</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600 }}>URL</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600 }}>Date</TableCell>
                    <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600, width: "15%" }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {landingPages.length > 0 ? (
                    landingPages.map((row, index) => (
                      <TableRow key={row.id} hover sx={{ "&:hover": { backgroundColor: "#F1F5F9" } }}>
                        <TableCell sx={{ fontSize: "0.75rem" }}>{index + 1}</TableCell>
                        <TableCell sx={{ fontSize: "0.75rem", fontWeight: 500 }}>{row.name}</TableCell>
                        <TableCell sx={{ fontSize: "0.75rem" }}>
                          <Box
                            sx={{
                              display: "inline-block",
                              px: 1,
                              py: 0.5,
                              borderRadius: "4px",
                              backgroundColor: row.linkType === "Website" ? "#E3F2FD" : "#FFF3E0",
                              color: row.linkType === "Website" ? "#1976d2" : "#f57c00",
                              fontSize: "0.7rem",
                              fontWeight: 500,
                            }}
                          >
                            {row.linkType}
                          </Box>
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.75rem" }}>
                          <Typography
                            sx={{
                              fontSize: "0.75rem",
                              maxWidth: "200px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            title={row.url}
                          >
                            {row.url}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.75rem" }}>{row.date}</TableCell>
                        <TableCell sx={{ fontSize: "0.75rem" }}>
                          <Box sx={{ display: "flex", gap: 0.5 }}>
                            <IconButton
                              size="small"
                              onClick={() => window.open(row.url, "_blank")}
                              sx={{ p: "4px" }}
                              title="Preview"
                            >
                              <ArrowBackIcon sx={{ fontSize: "16px", transform: "rotate(180deg)" }} />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleEdit(row)}
                              sx={{ p: "4px", color: "#1976d2" }}
                              title="Edit"
                            >
                              <EditIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(row.id)}
                              sx={{ p: "4px", color: "#d32f2f" }}
                              title="Delete"
                            >
                              <DeleteIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 3, fontSize: "0.85rem", color: "text.secondary" }}>
                        No landing pages created yet. Create one to get started.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid2>

        {/* Right Column - Info/Stats */}
        <Grid2 size={4}>
          <Card sx={{ p: 1.5, borderRadius: "12px", border: "1px solid #E2E8F0", mb: 2 }}>
            <SectionTitle title="Campaign Info" />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <Box sx={{ p: 1, backgroundColor: "#F8FAFC", borderRadius: "8px" }}>
                <Typography sx={{ fontSize: "0.7rem", color: "#666", mb: 0.5 }}>Total Pages</Typography>
                <Typography sx={{ fontSize: "1.5rem", fontWeight: 600, color: "#0F172A" }}>
                  {landingPages.length}
                </Typography>
              </Box>
              <Box sx={{ p: 1, backgroundColor: "#F8FAFC", borderRadius: "8px" }}>
                <Typography sx={{ fontSize: "0.7rem", color: "#666", mb: 0.5 }}>Website Links</Typography>
                <Typography sx={{ fontSize: "1.5rem", fontWeight: 600, color: "#1976d2" }}>
                  {landingPages.filter((p) => p.linkType === "Website").length}
                </Typography>
              </Box>
              <Box sx={{ p: 1, backgroundColor: "#F8FAFC", borderRadius: "8px" }}>
                <Typography sx={{ fontSize: "0.7rem", color: "#666", mb: 0.5 }}>Video Links</Typography>
                <Typography sx={{ fontSize: "1.5rem", fontWeight: 600, color: "#f57c00" }}>
                  {landingPages.filter((p) => p.linkType === "Youtube").length}
                </Typography>
              </Box>
            </Box>
          </Card>

          <Card sx={{ p: 1.5, borderRadius: "12px", border: "1px solid #E2E8F0" }}>
            <SectionTitle title="Quick Tips" />
            <Typography sx={{ fontSize: "0.75rem", lineHeight: 1.6, color: "#666" }}>
              ✓ Use descriptive names for your landing pages<br/>
              ✓ Ensure URLs are valid and accessible<br/>
              ✓ Test landing pages before using in campaigns<br/>
              ✓ Keep track of page performance metrics
            </Typography>
          </Card>
        </Grid2>
      </Grid2>

      {/* Edit Modal */}
      <Dialog
        open={open && editingId}
        onClose={() => {
          setOpen(false);
          setEditingId(null);
          setEditingData(null);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ fontSize: "1rem", fontWeight: 600 }}>Edit Landing Page</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          {editingData && (
            <>
              <TextField
                label="Landing Page Name"
                name="name"
                fullWidth
                size="small"
                value={editingData.name}
                onChange={handleEditChange}
                sx={{ mb: 2, ...compactField }}
                margin="normal"
              />
              <FormControl fullWidth size="small" sx={{ mb: 2, ...compactField }}>
                <InputLabel sx={{ fontSize: "0.7rem" }}>Link Type</InputLabel>
                <Select
                  label="Link Type"
                  name="linkType"
                  value={editingData.linkType}
                  onChange={handleEditChange}
                  sx={{ backgroundColor: "#fff" }}
                >
                  <MenuItem value="Website">Website</MenuItem>
                  <MenuItem value="Youtube">YouTube</MenuItem>
                  <MenuItem value="Custom">Custom</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="URL"
                name="url"
                fullWidth
                size="small"
                value={editingData.url}
                onChange={handleEditChange}
                sx={compactField}
                margin="normal"
              />
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 1.5 }}>
          <Button
            onClick={() => {
              setOpen(false);
              setEditingId(null);
              setEditingData(null);
            }}
            color="secondary"
            sx={{ fontSize: "0.72rem" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleEditSubmit}
            variant="contained"
            sx={{ fontSize: "0.72rem", textTransform: "none" }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StartClicker;
